import { Element, ELEMENT_TYPES, type SeparatorElement } from '@@editor/helpers/Element';
import { isUnitySeparator, type UnitySeparator } from '@@editor/typings/UnityElements';

import { type ElementRule } from '../../types';
import { CURRENT_VERSION } from './../../constants';

type Rule = ElementRule<SeparatorElement, UnitySeparator>;

const separatorRules: Rule = {
    deserialize: (element): ReturnType<Rule['deserialize']> => {
        if (isUnitySeparator(element)) {
            return {
                type: ELEMENT_TYPES.SEPARATOR,
                children: [{ text: '' }],
            };
        }
    },

    serialize: (node): ReturnType<Rule['serialize']> => {
        if (Element.isSeparatorElement(node)) {
            return {
                version: CURRENT_VERSION,
                type: ELEMENT_TYPES.SEPARATOR,
            };
        }
    },
};

export default separatorRules;
